RivalIQ.apps.AccountSettings.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const Widget = widgets.ConnectedServices = RivalIQ.apps.Dashboard.models.Widget.extend({
        view: App.views.AccountConnections,
        viewMore: false,
        title: RivalIQ.strings.connected_services_widget_title,
        exportFormats: []
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.CONNECTED_SERVICES, Widget);
});
